import classNames from 'classnames';
import Footer from 'components/Footer';
import Header from 'components/Header';
import React from 'react';
import Style from 'styles/components/comachi.layout.module.scss';

const Layout = ({children}) => {
  return (
    <div id='root' className={classNames(Style.header_padding)}>
      <Header />
      <main className={Style.main}>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
